import {useCallback} from "react";
import {resolveToOwners} from "../../../api/owners";
import {
  additionsToResolve,
  assertRolesDisjoint,
  buildRequests,
  type ApplyPlan,
  type RemovalScope,
} from "./reviewCandidates";
import {useCreateReviews} from "./useCreateReviews";
import type {ReviewItem} from ".";
import {useReviewSource} from "./ReviewSource";

/**
 * Write one or more role changes. Each plan's removals are sent before its additions, so a
 * failure part-way leaves the page short of reviewers rather than holding unwanted ones.
 */
export function useReviewCommit(reviewItem: ReviewItem) {
  const createReviews = useCreateReviews(reviewItem);
  const resolveOwners = useReviewSource()?.resolveOwners ?? resolveToOwners;

  return useCallback(
    async (plans: ApplyPlan[], scope: RemovalScope) => {
      assertRolesDisjoint(plans);
      for (const plan of plans) {
        const resolved = await resolveOwners(additionsToResolve(plan));
        for (const request of buildRequests(plan, scope, resolved)) {
          await createReviews(request.actions, request.cascade);
        }
      }
    },
    [createReviews, resolveOwners],
  );
}
